module.exports = __webpack_public_path__ + "img/slot.c82e994.webp";